export default "__VITE_ASSET__CD4Eb_VG__"